module.exports = __webpack_public_path__ + "img/7_84.8d499621.png";